import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { SelectOption } from "../components/Option/option.index";

export function useVisibleTags(tags: SelectOption[]) {
  const containerRef = useRef<HTMLDivElement>(null);
  const tagRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const plusRef = useRef<HTMLButtonElement>(null);
  const triggerButtonRef = useRef<HTMLButtonElement>(null);

  const [visibleCount, setVisibleCount] = useState(tags.length);

  const updateVisibleCount = () => {
    if (!containerRef.current || !plusRef.current) return;

    const containerWidth = containerRef.current.clientWidth;

    const plusWidth = plusRef.current.offsetWidth;

    let usedWidth = 0;
    let count = 0;

    for (let i = 0; i < tags.length; i++) {
      const tagEl = tagRefs.current[i];

      if (!tagEl) {
        return;
      }

      const tagWidth = tagEl.offsetWidth;

      const totalGaps = count * 4;

      if (usedWidth + tagWidth + plusWidth + totalGaps <= containerWidth) {
        usedWidth += tagWidth;
        count++;
      } else {
        break;
      }
    }

    setVisibleCount(count);
  };

  useLayoutEffect(() => {
    const timeout = setTimeout(() => {
      updateVisibleCount();
    }, 0);

    return () => clearTimeout(timeout);
  }, [tags]);

  useEffect(() => {
    if (!triggerButtonRef.current) return;

    const observer = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        const next = tags.length;

        setVisibleCount((prev) => (prev === next ? prev : next));
      });
    });

    observer.observe(triggerButtonRef.current);

    return () => observer.disconnect();
  }, [tags]);

  return { containerRef, tagRefs, plusRef, triggerButtonRef, visibleCount };
}
